import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UToggleButtonComponent } from './u-toggle-button.component';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  declarations: [UToggleButtonComponent],
  imports: [CommonModule, FormsModule, MatButtonToggleModule],
  exports: [UToggleButtonComponent],
})
export class UToggleButtonModule {}
